/**
 * Schedule indicator colors aligned with Project Dashboard `getSPIMsg`
 * (Schedule Performance Index / delay messaging).
 */
export type SpiScheduleDelayRange = {
  onTimeDelayMax: number;
  moderateDelayMax: number;
};

const GREEN = "#22C55E"; // text-green-500
const RED = "#EF4444"; // text-red-500
const AMBER = "#FBBF24"; // moderate delay

export function getSpiScheduleIndicatorHex(
  spi: number | null | undefined,
  delayRange: SpiScheduleDelayRange,
): string {
  const pct = Number(spi);
  if (!Number.isFinite(pct)) {
    return GREEN;
  }
  const diff = Math.abs(100 - pct);
  const isAhead = pct >= 100;
  if (isAhead) {
    return GREEN;
  }
  if (diff > delayRange.moderateDelayMax) {
    return RED;
  }
  if (diff > delayRange.onTimeDelayMax) {
    return AMBER;
  }
  return GREEN;
}
